import { Typography } from '@material-ui/core'
import styled, { ITheme } from '../../../../../theme'

export default styled(Typography)`
  && {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.1px;
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 190px;
    color: ${(props: ITheme) => props.theme.colors.palette.emerald};
  }
`
